export const mockGuardians = [
  {
    id: '1',
    name: 'Allison Thompson',
    relationship: 'Mother',
    personality: 'Analytical and detail-oriented',
    communicationStyle: 'Asks lots of specific questions, wants data and evidence-based explanations. Appreciates structured information and clear timelines.',
    concerns: ['Wants to understand every aspect of the treatment plan', 'Worried about long-term outcomes', 'Needs reassurance about progress'],
    strengths: ['Very engaged and supportive', 'Follows through on recommendations', 'Good at implementing strategies at home'],
    preferredCommunication: 'Detailed written summaries with verbal explanations',
    backgroundInfo: 'Works in healthcare administration, has researched ABA extensively online before starting services'
  },
  {
    id: '2',
    name: 'Carlos Rodriguez',
    relationship: 'Father',
    personality: 'Practical and solution-focused',
    communicationStyle: 'Direct and to-the-point, prefers actionable advice over theory. Can be skeptical but becomes supportive once he sees results.',
    concerns: ['Worried about cost and time investment', 'Wants to see immediate practical improvements', 'Concerned about impact on family routine'],
    strengths: ['Very motivated to help his daughter', 'Good at problem-solving', 'Willing to make changes once convinced'],
    preferredCommunication: 'Brief, clear explanations with concrete examples and next steps',
    backgroundInfo: 'Works in construction management, values efficiency and practical solutions. Initially hesitant about therapy but becoming more engaged'
  }
];